/**
 * Settings page.
 */

import { Card } from '@/components/ui/card';
import { useMe } from '@/hooks/useAuth';
import { LoadingSpinner } from '@/components/ui/loading';
import './index.scss';

export function Settings() {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="settings">
      <div className="settings__header">
        <h1 className="h1">Settings</h1>
        <p className="subtitle">Manage your account and preferences</p>
      </div>

      <Card>
        <h2 className="h3" style={{ marginBottom: 'var(--of-space-4)' }}>Organization</h2>
        {me && (
          <div className="space-y-2">
            <div className="settings__org-field">
              <p>Name</p>
              <p>{me.org.name}</p>
            </div>
            <div className="settings__org-field">
              <p>Plan</p>
              <p>{me.org.plan || 'Free'}</p>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}

